interface StatusBarProps {
  zoom: number;
  canvasWidth: number;
  canvasHeight: number;
  cursorX: number;
  cursorY: number;
  colorUnderCursor: string;
}

export function StatusBar({
  zoom,
  canvasWidth,
  canvasHeight,
  cursorX,
  cursorY,
  colorUnderCursor,
}: StatusBarProps) {
  return (
    <div className="flex items-center h-7 bg-background border-t border-border px-3 text-xs text-muted-foreground gap-4 select-none">
      <span className="tabular-nums">{Math.round(zoom * 100)}%</span>
      <span className="w-px h-3.5 bg-border" />
      <span className="tabular-nums">
        {canvasWidth} x {canvasHeight}
      </span>
      <span className="w-px h-3.5 bg-border" />
      <span className="tabular-nums">
        X: {cursorX} Y: {cursorY}
      </span>
      <span className="w-px h-3.5 bg-border" />
      <span className="flex items-center gap-1.5">
        <span
          className="inline-block w-3.5 h-3.5 rounded border border-border"
          style={{ backgroundColor: colorUnderCursor }}
        />
        <span className="tabular-nums uppercase">{colorUnderCursor}</span>
      </span>
    </div>
  );
}
